<template>
  <div>dsds</div>
</template>
<script>
export default {
  components: {},
  props: [],
  data() {
    return {};
  },
  mounted() {
    //window.fbAsyncInit = function() {};

    setTimeout(() => {
      window.FB.getLoginStatus(function(response) {
        if (response.status === "connected") {
          var fbAccessToken = response.authResponse.accessToken;
          console.log(fbAccessToken);

          window.FB.api("/HalalHeroTH/conversations", function(response) {
            if (response && !response.error) {
              /* handle the result */
            }
          });
        } else {
          window.FB.login(
            function(response) {
              if (response.authResponse) {
                console.log(response.authResponse.accessToken);
                console.log("Welcome!  Fetching your information.... ");

                window.FB.api("/me", function(response) {
                  console.log("Good to see you, " + response.name + ".");
                });
              } else {
                console.log("User cancelled login or did not fully authorize.");
              }
            },
            {
              scope:
                "public_profile,email,pages_manage_metadata,pages_messaging,pages_read_engagement"
            }
          );
        }
      });
    }, 2000);
  }
};
</script>